module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-405.bfac8b0.woff2";